import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsHeaderSliderBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsHeaderSliderBlockEntity
